// extracted by mini-css-extract-plugin
export default {"inputs":"rYOil","numberInputWrapper":"eUKgF","numberInput":"YNZJL"};